const initialState = {
    isModalVisible: false,
  };
  
  const soldAdsModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_SOLD_ADS_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_SOLD_ADS_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default soldAdsModalReducer;
  